import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./PositionReportSpain.css";
import { useEffect, useState } from "react";
import { numToDecimalString, numToCurrency, currencyToNum } from "./utils/transformators";
import moment from "moment";
import { stgpmtcalc } from "./utils/calculations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import useSPPosition from "../../hooks/useSPPosition";
import USPosMatchingToolTip from "./USPosMatchingToolTip";
import USPosPriceToolTip from "./USPosPriceToolTip";

const PositionReportSpain = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  // Context Values
  const { positiontoeditSP, setPositiontoeditSP } = useSPPosition();
  // States
  const [gdata, setGdata] = useState();
  const [spposmatchnumber, setSPposmatchnumber] = useState();
  const [datalength, setDatalength] = useState();
  const [spposmatch, setSPposmatch] = useState(0);
  const [mktpricedata, setMktpricedata] = useState();
  // function to group data
  // eslint-disable-next-line no-extend-native
  Array.prototype.groupBy = function (key) {
    return this.reduce(function (groups, item) {
      const val = item[key];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };
  // load data
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await axiosPrivate.get("/api/positions/loadsppositionreport");
        console.log(response.data);
        setDatalength(response.data.length);
        setGdata(response.data.groupBy("productGroup"));
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    fetchdata();
  }, []);
  // load mkt price updates
  useEffect(() => {
    const fetchdata = async () => {
      const response = await axiosPrivate.post("/api/positions/loadspmktpriceupdates");
      setMktpricedata(response.data);
    };
    fetchdata();
  }, []);
  // Navigate to selected position
  const handleNavToSPPos = (posID) => {
    navigate("/positions/spain", { state: { positiontoedit: posID } });
  };

  // Input handlers
  const handleMktPriceValue = (id) => {
    if (mktpricedata) {
      let result = mktpricedata.filter((item) => {
        return item.SPposID === id;
      });
      if (result[0]) {
        return numToCurrency(result[0]["mktpriceupdate"]);
      } else {
        return "N/A";
      }
    }
  };
  const handleMktValue = (id, inv) => {
    if (mktpricedata) {
      let result = mktpricedata.filter((item) => {
        return item.SPposID === id;
      });
      if (result[0]) {
        return numToCurrency(result[0]["mktpriceupdate"] * inv, 0);
      } else {
        return "N/A";
      }
    }
  };

  const handlePProfit = (id, inv, pr, stg) => {
    if (mktpricedata) {
      let result = mktpricedata.filter((item) => {
        return item.SPposID === id;
      });
      if (result[0]) {
        return numToCurrency(
          (result[0]["mktpriceupdate"] - Number(pr.toFixed(2).replace(/[^0-9.-]+/g, "")) - stg) * inv,
          0
        );
      } else {
        return "N/A";
      }
    }
  };

  var sumu = 0;
  var sumuplts = 0;
  var sumcurrval = 0;
  var ind = 0;
  var ttlmktval = 0;
  var ttlprof = 0;

  return (
    <div className='sppositionreport'>
      <div className='sppositionreport-header'>
        <div style={{ textAlign: "left", flexBasis: 0 }}>SPWGP</div>
        <div className='fig'>Quantity</div>
        <div className='fig'>Inventory</div>
        <div className='fig'>In Pallets</div>
        <div className='fig'>Warehouse</div>
        <div className='fig'>Cost</div>
        <div className='fig'>Storage</div>
        <div className='fig'>COGS</div>
        <div className='fig'>Supplier</div>
        {/* <div className='fig'>From</div> */}
        <div className='fig'>WH Entry</div>
        <div className='fig'>COGSValue</div>
        <div className='fig'>MktPrice</div>
        <div className='fig'>MktValue</div>
        <div className='fig'>PProfit</div>
      </div>
      {/* Body */}
      <div className='sppositionreport-body'>
        {gdata &&
          Object.entries(gdata).map(([groupName, groupData]) => {
            const products = groupData.groupBy("product");
            return (
              <div key={groupName} className='spposition-group'>
                <div className='spprodgroup'>{groupName}</div>
                {Object.entries(products).map(([productName, productItems]) => {
                  let u = 0; // quantity
                  let uplts = 0; // pallets
                  let currval = 0; // cost value
                  let prodttlmktval = 0; // market value
                  let prodttlprft = 0; // profit
                  return (
                    <div key={productName} className='spproduct-block'>
                      <div className='spproduct'>{productName}</div>
                      {productItems.map((x, i) => {
                        sumu += Number(x.inventory);
                        u += Number(x.inventory);
                        uplts += Number(x.inventoryPallets);
                        sumuplts += Number(x.inventoryPallets);
                        ind += 1;
                        const daysInStorage = Math.max(
                          moment().diff(moment(x.whentrydate, "YYYY-MM-DD"), "days") - x.whgraceperiod,
                          0
                        );
                        const stg = stgpmtcalc(
                          daysInStorage,
                          x.whfixedcost,
                          x.whvarcost,
                          x.quantity,
                          x.numpallets,
                          x.whaccrualperiod
                        );
                        currval += x.inventory * (x.EWPrice + stg);
                        sumcurrval += x.inventory * (x.EWPrice + stg);
                        let mktval = handleMktValue(x.SPposID, x.inventory);
                        if (mktval && mktval !== "N/A") {
                          ttlmktval = ttlmktval + currencyToNum(mktval);
                          prodttlmktval = prodttlmktval + currencyToNum(mktval);
                        }
                        let prft = handlePProfit(x.SPposID, x.inventory, x.EWPrice, stg);
                        if (prft && prft !== "N/A") {
                          ttlprof = ttlprof + currencyToNum(prft);
                          prodttlprft = prodttlprft + currencyToNum(prft);
                        }
                        return (
                          <div key={i} className='spposition-row'>
                            <div style={{ position: "relative", textAlign: "left", flexBasis: 0 }}>
                              <div
                                onMouseEnter={() => setSPposmatchnumber(x.WGP)}
                                onMouseLeave={() => setSPposmatchnumber(0)}
                                onClick={() => handleNavToSPPos(x.SPposID)}
                                style={{ color: "var(--blue)", flexBasis: 0 }}
                              >
                                {x.WGP}{" "}
                              </div>
                              <USPosMatchingToolTip
                                listlength={datalength}
                                itemindex={datalength - ind}
                                usposnumber={x.WGP}
                                usposmatchnumber={spposmatchnumber}
                                url='spposmatching'
                              />
                            </div>
                            <div className='fig'>{numToDecimalString(x.quantity)}</div>
                            <div className='fig'>{numToDecimalString(x.inventory)}</div>
                            <div className='fig'>{numToDecimalString(x.inventoryPallets)}</div>
                            <div className='fig'>{x.warehouse}</div>
                            <div className='fig'>{numToCurrency(x.EWPrice)}</div>
                            <div className='fig'>{numToCurrency(stg)}</div>
                            <div className='fig'>{numToCurrency(x.EWPrice + stg)}</div>
                            <div className='fig'>{x.supplier}</div>
                            {/* <div className='fig'>{moment(x.shipfrom).format("DD-MMM")}</div> */}
                            <div className='fig'>{moment(x.whentrydate).format("DD-MMM")}</div>
                            <div className='fig'>{numToCurrency(x.inventory * (x.EWPrice + stg), 0)}</div>
                            <div className='mktpriceupdate fig' style={{ position: "relative", flexDirection: "row" }}>
                              <FontAwesomeIcon
                                style={{ marginRight: "5px" }}
                                onClick={(e) => {
                                  if (x.SPposID === spposmatch) {
                                    setSPposmatch(0);
                                  } else {
                                    setSPposmatch(x.SPposID);
                                  }
                                }}
                                icon={faPlusCircle}
                              />{" "}
                              <USPosPriceToolTip
                                usposid={x.SPposID}
                                usposmatch={spposmatch}
                                setUSposmatch={setSPposmatch}
                                setMktpricedata={setMktpricedata}
                                url1='addspmktprice'
                                url2='loadspmktpriceupdates'
                              />
                              {handleMktPriceValue(x.SPposID)}
                            </div>
                            <div className='fig'>{handleMktValue(x.SPposID, x.inventory)}</div>
                            <div className='fig'>{handlePProfit(x.SPposID, x.inventory, x.EWPrice, stg)}</div>
                          </div>
                        );
                      })}

                      <div className='usposreporttotals usposition-row'>
                        <div style={{ flexBasis: 0 }}></div> {/* USWGP */}
                        <div></div> {/* Quantity */}
                        <div className='fig'>{numToDecimalString(u)}</div> {/* Inventory total */}
                        <div className='fig'>{numToDecimalString(uplts)}</div> {/* In Pallets total */}
                        <div></div> {/* Warehouse */}
                        <div></div> {/* Cost */}
                        <div></div> {/* Storage */}
                        <div className='fig'>{numToCurrency(currval / u, 2)}</div> {/* EW Price */}
                        <div></div> {/* Supplier */}
                        {/* <div></div> From */}
                        <div></div> {/* To */}
                        <div className='fig'>{numToCurrency(currval, 0)}</div> {/* CostValue total */}
                        <div></div>
                        <div className='fig'>{numToCurrency(prodttlmktval, 0)}</div>
                        <div className='fig'>{numToCurrency(prodttlprft, 0)}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
      <div className='usposreporttotals usposition-row'>
        <div style={{ textAlign: "left", flexBasis: 0 }}>TOTAL:</div> {/* USWGP */}
        <div></div> {/* Quantity */}
        <div className='fig'>{numToDecimalString(sumu)}</div>
        <div className='fig'>{numToDecimalString(sumuplts)}</div>
        <div></div> {/* Warehouse */}
        <div></div> {/* Cost*/}
        <div></div> {/* Storage */}
        <div></div> {/* COGS*/}
        <div></div> {/* Supplier */}
        {/* <div></div> From */}
        <div></div> {/* To */}
        <div className='fig'>{numToCurrency(sumcurrval, 0)}</div> {/* CostValue total */}
        <div></div> {/* To */}
        <div className='fig'>{numToCurrency(ttlmktval, 0)}</div>
        <div className='fig'>{numToCurrency(ttlprof, 0)}</div>
      </div>
    </div>
  );
};

export default PositionReportSpain;
